import getClosestFlyoutContainer from "./getClosestFlyoutContainer";
import getScrollbarWidth from "../scroll/getScrollbarWidth";
import getPositionOrder from "./getPositionOrder";
import calculatePosition from "./calculatePosition";
import isFullyVisible from "./isFullyVisible";
import { RESET_STYLES } from "./constants";
/**
 * Set position of the target element to fit on the screen
 */
const getInBoundsPosition = (origin, target, options) => {
    const { position, forcePosition, zIndex, relative } = options;
    const container = options.container || getClosestFlyoutContainer(origin);
    const targetClone = target.cloneNode(true);
    // Reset all styles applied on the previous hook execution
    targetClone.removeAttribute("style");
    Object.keys(RESET_STYLES).forEach((key) => {
        const value = RESET_STYLES[key];
        targetClone.style[key] = value.toString();
    });
    container.appendChild(targetClone);
    let originBounds = origin.getBoundingClientRect();
    const targetBounds = targetClone.getBoundingClientRect();
    if (container && container !== document.body) {
        const style = window.getComputedStyle(container);
        if (style?.position !== "relative") {
            console.warn(options.container
                ? "BUI Flyout: when mounting flyout to the container, make sure it has relative position set"
                : "BUI Flyout: flyout was mounted to the first found suitable container, make sure container has relative position set", container);
        }
        const containerBounds = container.getBoundingClientRect();
        const scrollbarWidth = getScrollbarWidth();
        const hasVerticalScrollbar = container.scrollHeight > container.clientHeight;
        const containerLeft = options.rtl && hasVerticalScrollbar
            ? containerBounds.left + scrollbarWidth
            : containerBounds.left;
        originBounds = {
            ...{
                top: originBounds.top,
                right: originBounds.right,
                bottom: originBounds.bottom,
                left: originBounds.left,
                width: originBounds.width,
                height: originBounds.height,
                x: originBounds.x,
                y: originBounds.y,
            },
            top: originBounds.top - containerBounds.top,
            right: originBounds.left - containerLeft + originBounds.width,
            bottom: originBounds.top - containerBounds.top + originBounds.height,
            left: originBounds.left - containerLeft,
        };
    }
    const order = getPositionOrder(position);
    const mobileOrder = order.filter((position) => position === "top" || position === "bottom");
    let calculated = calculatePosition(originBounds, targetBounds, {
        ...options,
        container,
    });
    const test = (items, extraOptions) => {
        items.some((currentPosition) => {
            const tested = calculatePosition(originBounds, targetBounds, {
                ...options,
                ...extraOptions,
                position: currentPosition,
                container,
                zIndex,
            });
            if (isFullyVisible(tested.bounds, container, { relative }) ||
                // We're ok with the first option after we got to mobile if that position if forced
                extraOptions?.mobileFallback) {
                calculated = tested;
                return true;
            }
            return false;
        });
    };
    if (!isFullyVisible(calculated.bounds, container, { relative }) &&
        !forcePosition) {
        test(order);
        // Second run to prioritize mobile positions
        // for not-fitting content
        if (!isFullyVisible(calculated.bounds, container, { relative })) {
            test(mobileOrder, { mobileFallback: true });
        }
    }
    targetClone.parentNode.removeChild(targetClone);
    return calculated;
};
export default getInBoundsPosition;
